var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 208V48C256 21.6 234.4 0 208 0H48C21.6 0 0 21.6 0 48V208C0 234.4 21.6 256 48 256H208C234.4 256 256 234.4 256 208ZM48 48H208V208H48V48ZM592 256H432C405.6 256 384 277.6 384 304V464C384 490.4 405.6 512 432 512H592C618.4 512 640 490.4 640 464V304C640 277.6 618.4 256 592 256ZM592 464H432V304H592V464ZM480 224V160C480 124.652 451.346 96 416 96H288V224C288 259.346 259.346 288 224 288H160V352C160 387.346 188.654 416 224 416H352V288C352 252.652 380.654 224 416 224H480Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendBack);
export default __webpack_public_path__ + "static/media/send-back.f048a424f2239f408dcba7dabb8cddc4.svg";
export { ForwardRef as ReactComponent };